import { BrowserRouter, Route, Routes } from "react-router";
import "./App.css";
import MainPage from "./pages/main";
import HomePage from "./pages/home";
import FlashcardPage from "./pages/flashcard";
import EditorPage from "./pages/editorPage";
import { useEffect } from "react";
import { useCategoryList } from "./zustand/requests";
import AccountPage from "./pages/account";
import RoadSignsPage from "./pages/roadSignsPage";

function App() {
  const list = useCategoryList();
  useEffect(() => {
    list.execute();
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<MainPage />}>
          <Route path="" element={<HomePage />} />
          <Route path="/me" element={<AccountPage />} />
        </Route>
        <Route path="/flashcard" element={<FlashcardPage />} />
        <Route path="/edit" element={<EditorPage />} />
        <Route path="/road-signs" element={<RoadSignsPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
